module.exports = __webpack_public_path__ + "media/1x1/ve-9f23d962.svg";